const items = [
  "Rétablissement",
  "Pair-aidance",
  "Médecine personnelle",
  "25+ pays",
  "En français",
  "Certification CPMC",
  "100 % en ligne",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="cpmc-editorial-marquee"
      className="overflow-hidden border-y border-ink/10 bg-ink py-4"
    >
      <div className="flex w-max animate-marquee items-center gap-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10">
                <span className="whitespace-nowrap font-display text-lg font-bold uppercase tracking-wide text-cream/90">
                  {item}
                </span>
                <span className="h-2 w-2 rounded-full bg-sun" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
